import { useState } from 'react';
import type { GetStaticPropsContext } from 'next';

import { useTranslations } from '@keymono/i18n';
import { MessageArrived, IllustrationNewLetter } from '@keymono/design-system';

import { loadPageTranslations } from '@translations';
import { AuthPagesLayout } from '@layouts/AuthPagesLayout';
import { DynamicSignUpForm } from '@features/user-accounts';
import Head from 'next/head';

export async function getStaticProps({ locale = 'en' }: GetStaticPropsContext) {
  const { SignUp, Common } = await loadPageTranslations({ locale });

  return {
    props: { messages: { SignUp, Common } },
  };
}

/**
 * -----------------------------------------------------------------------------
 * The sign up screen
 * TODO: ADD SEOMetaData
 */
export default function SignUpPage() {
  const t = useTranslations('SignUp');

  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const handleFormSubmitSuccess = () => {
    setIsFormSubmitted(true);
  };

  const handleRetrySignUp = () => {
    setIsFormSubmitted(false);
  };

  return (
    <>
      <Head>
        <title>{t('browserTitle')}</title>
      </Head>
      <AuthPagesLayout
        leftChildren={
          <DynamicSignUpForm
            isFormSubmitted={isFormSubmitted}
            onRetrySignUp={handleRetrySignUp}
            onSubmitSuccess={handleFormSubmitSuccess}
          />
        }
        rightChildren={
          isFormSubmitted ? <MessageArrived /> : <IllustrationNewLetter />
        }
        backgroundClass={isFormSubmitted ? 'rotate-180' : ''}
      />
    </>
  );
}
